import React, { useState } from "react";
import { useParams } from "react-router-dom";
import CashSale from "./types/CashSale";
import CustomerOrder from "./types/CustomerOrder";

export default function Transaction() {
  let { type } = useParams();
  console.log(`sew${type}ber`);
  let value;

  switch (type) {
    case "Cash-Sales":
      value = <CashSale />;
      break;
    case "Customer-Order":
      value = <CustomerOrder />;
      break;
    default:
      value = <div>404 not found</div>;
      break;
  }

  return value;
}
